(function($, window, document, undefined) {
	var defaults = {
		bounds: true,
		country: "CA",
		map: false,
		details: false,
		detailsAttribute: "name",
		autoselect: true,
		location: false,
		details: ".details",
		detailsAttribute: "data-geo",
		mapOptions: {
			zoom: 13,
			scrollwheel: false,
			mapTypeId: "roadmap"
		},
		markerOptions: {
			draggable: false
		},
		maxZoom: 14,
		types: ['geocode'],
		blur: false,
		geocodeAfterResult: false
	};
	var componentTypes = ("street_address route intersection political " + "country administrative_area_level_1 administrative_area_level_2 " + "administrative_area_level_3 colloquial_area locality sublocality " + "neighborhood premise subpremise postal_code natural_feature airport " + "park point_of_interest post_box street_number floor room " + "lat lng viewport location " + "formatted_address location_type bounds").split(" ");
	var placesDetails = ("id place_id url website vicinity reference name rating " + "international_phone_number icon formatted_phone_number").split(" ");
	function GeoComplete(input, options) {
		this.options = $.extend(true, {}, defaults, options);
		this.input = input;
		this.$input = $(input);
		this._defaults = defaults;
		this._name = 'geocomplete';
		this.init();
	}
	$.extend(GeoComplete.prototype, {
		init: function() {
			this.initMap();
			this.foo();
			this.initMarker();
			this.initGeocoder();
			this.initDetails();
			this.initLocation();
		},
		initMap: function() {
			if (!this.options.map) {
				return;
			}
			if (typeof this.options.map.setCenter == "function") {
				this.map = this.options.map;
				return;
			}
			this.map = new google.maps.Map($(this.options.map)[0], this.options.mapOptions);
			google.maps.event.addListener(this.map, 'click', $.proxy(this.mapClicked, this));
			google.maps.event.addListener(this.map, 'zoom_changed', $.proxy(this.mapZoomed, this));
		},
		foo: function() {
			var ctaLayer = new google.maps.KmlLayer({
				url: 'https://cdn.shopify.com/s/files/1/0336/7501/files/SUPERMARCHE_PA_ZONES_DE_LIVRAISON_SEPT_2022.kmz?v=1664462522'
			});
			ctaLayer.setMap(this.map);
			var nature = new google.maps.LatLng(45.49474129548688, -73.64865023226783);
			var natureMarker = new google.maps.Marker({
				position: nature,
				map: this.map,
				icon: 'https://cdn.shopify.com/s/files/1/0336/7501/files/pa-solo-map.png?8635855332544861424',
				title: 'PA Westbury'
			});
			ctaLayer.setMap(this.map);
			var nature = new google.maps.LatLng(45.520529, -73.598603);
			var natureMarker = new google.maps.Marker({
				position: nature,
				map: this.map,
				icon: 'https://cdn.shopify.com/s/files/1/0336/7501/files/pa-solo-map.png?8635855332544861424',
				title: 'PA du Parc'
			});
			ctaLayer.setMap(this.map);
			var nature = new google.maps.LatLng(45.52827569999999, -73.75663099999997);
			var natureMarker = new google.maps.Marker({
				position: nature,
				map: this.map,
				icon: 'https://cdn.shopify.com/s/files/1/0336/7501/files/pa-solo-map.png?8635855332544861424',
				title: 'PA Samson'
			});
			ctaLayer.setMap(this.map);
			var nature = new google.maps.LatLng(45.492108, -73.582389);
			var natureMarker = new google.maps.Marker({
				position: nature,
				map: this.map,
				icon: 'https://cdn.shopify.com/s/files/1/0336/7501/files/pa-solo-map.png?8635855332544861424',
				title: 'PA du Fort'
			});
		},
		initMarker: function() {
			if (!this.map) {
				return;
			}
			var options = $.extend(this.options.markerOptions, {
				map: this.map
			});
			if (options.disabled) {
				return;
			}
			this.marker = new google.maps.Marker(options);
			google.maps.event.addListener(this.marker, 'dragend', $.proxy(this.markerDragged, this));
		},
		initGeocoder: function() {
			var selected = false;
			var options = {
				types: this.options.types,
				bounds: this.options.bounds === true ? null : this.options.bounds,
				componentRestrictions: this.options.componentRestrictions
			};
			if (this.options.country) {
				options.componentRestrictions = {
					country: this.options.country
				};
			}
			// this.autocomplete = new google.maps.places.Autocomplete(this.input, options);
			this.autocomplete = new google.maps.places.Autocomplete(this.input, {
				// fields: ['address_components', "name", "geometry.location", "place_id", "formatted_address"]
				fields: ['address_components', "name", "geometry.location", "formatted_address"]
			});
			this.geocoder = new google.maps.Geocoder();
			if (this.map && this.options.bounds === true) {
				this.autocomplete.bindTo('bounds', this.map);
			}
			google.maps.event.addListener(this.autocomplete, 'place_changed', $.proxy(this.placeChanged, this));
			this.$input.keypress(function(event) {
				if (event.keyCode === 13) {
					return false;
				}
			});
			if (this.options.geocodeAfterResult === true) {
				this.$input.bind('keypress', $.proxy(function() {
					if (event.keyCode != 9 && this.selected === true) {
						this.selected = false;
					}
				}, this));
			}
			this.$input.bind("geocode", $.proxy(function() {
				this.find();
			}, this));
			if (this.options.blur === true) {
				this.$input.blur($.proxy(function() {
					if (this.options.geocodeAfterResult === true && this.selected === true) {
						return;
					}
					this.find();
				}, this));
			}
		},
		initDetails: function() {
			if (!this.options.details) {
				return;
			}
			var $details = $(this.options.details),
				attribute = this.options.detailsAttribute,
				details = {};
			function setDetail(value) {
				details[value] = $details.find("[" + attribute + "=" + value + "]");
			}
			$.each(componentTypes, function(index, key) {
				setDetail(key);
				setDetail(key + "_short");
			});
			$.each(placesDetails, function(index, key) {
				setDetail(key);
			});
			this.$details = $details;
			this.details = details;
		},
		initLocation: function() {
			var location = this.options.location,
				latLng;
			if (!location) {
				return;
			}
			if (typeof location == 'string') {
				this.find(location);
				return;
			}
			if (location instanceof Array) {
				latLng = new google.maps.LatLng(location[0], location[1]);
			}
			if (location instanceof google.maps.LatLng) {
				latLng = location;
			}
			if (latLng) {
				if (this.map) {
					this.map.setCenter(latLng);
				}
				if (this.marker) {
					this.marker.setPosition(latLng);
				}
			}
		},
		find: function(address) {
			this.geocode({
				address: address || this.$input.val()
			});
		},
		geocode: function(request) {
			if (this.options.bounds && !request.bounds) {
				if (this.options.bounds === true) {
					request.bounds = this.map && this.map.getBounds();
				} else {
					request.bounds = this.options.bounds;
				}
			}
			if (this.options.country) {
				request.region = this.options.country;
			}
			this.geocoder.geocode(request, $.proxy(this.handleGeocode, this));
		},
		selectFirstResult: function() {
			var selected = '';
			if ($(".pac-item-selected")[0]) {
				selected = '-selected';
			}
			var $span1 = $(".pac-container:last .pac-item" + selected + ":first span:nth-child(2)").text();
			var $span2 = $(".pac-container:last .pac-item" + selected + ":first span:nth-child(3)").text();
			var firstResult = $span1;
			if ($span2) {
				firstResult += " - " + $span2;
			}
			this.$input.val(firstResult);
			return firstResult;
		},
		handleGeocode: function(results, status) {
			if (status === google.maps.GeocoderStatus.OK) {
				var result = results[0];
				this.$input.val(result.formatted_address);
				this.update(result);
				if (results.length > 1) {
					this.trigger("geocode:multiple", results);
				}
			} else {
				this.trigger("geocode:error", status);
			}
		},
		trigger: function(event, argument) {
			this.$input.trigger(event, [argument]);
		},
		center: function(geometry) {
			if (geometry.viewport) {
				this.map.fitBounds(geometry.viewport);
				if (this.map.getZoom() > this.options.maxZoom) {
					this.map.setZoom(this.options.maxZoom);
				}
			} else {
				this.map.setZoom(this.options.maxZoom);
				this.map.setCenter(geometry.location);
			}
			if (this.marker) {
				this.marker.setPosition(geometry.location);
				this.marker.setAnimation(this.options.markerOptions.animation);
			}
		},
		update: function(result) {
			if (this.map) {
				this.center(result.geometry);
				checkpostalcode ();
			}
			if (this.$details) {
				this.fillDetails(result);
				checkpostalcode ()
			}
			this.trigger("geocode:result", result);
		},
		fillDetails: function(result) {
			var data = {},
				geometry = result.geometry,
				viewport = geometry.viewport,
				bounds = geometry.bounds;
			$.each(result.address_components, function(index, object) {
				var name = object.types[0];
				$.each(object.types, function(index, name) {
					data[name] = object.long_name;
					data[name + "_short"] = object.short_name;
				});
			});
			$.each(placesDetails, function(index, key) {
				data[key] = result[key];
			});
			$.extend(data, {
				formatted_address: result.formatted_address,
				location_type: geometry.location_type || "PLACES",
				viewport: viewport,
				bounds: bounds,
				location: geometry.location,
				lat: geometry.location.lat(),
				lng: geometry.location.lng()
			});
			$.each(this.details, $.proxy(function(key, $detail) {
				var value = data[key];
				this.setDetail($detail, value);
			}, this));
			this.data = data;
		},
		setDetail: function($element, value) {
			if (value === undefined) {
				value = "";
			} else if (typeof value.toUrlValue == "function") {
				value = value.toUrlValue();
			}
			if ($element.is(":input")) {
				$element.val(value);
			} else {
				$element.text(value);
			}
		},
		markerDragged: function(event) {
			this.trigger("geocode:dragged", event.latLng);
		},
		mapClicked: function(event) {
			this.trigger("geocode:click", event.latLng);
		},
		mapZoomed: function(event) {
			this.trigger("geocode:zoom", this.map.getZoom());
		},
		resetMarker: function() {
			this.marker.setPosition(this.data.location);
			this.setDetail(this.details.lat, this.data.location.lat());
			this.setDetail(this.details.lng, this.data.location.lng());
		},
		placeChanged: function() {
			var place = this.autocomplete.getPlace();
			this.selected = true;
			if (!place.geometry) {
				if (this.options.autoselect) {
					var autoSelection = this.selectFirstResult();
					this.find(autoSelection);
				}
			} else {
				this.update(place);
			}
		}
	});
	$.fn.geocomplete = function(options) {
		var attribute = 'plugin_geocomplete';
		if (typeof options == "string") {
			var instance = $(this).data(attribute) || $(this).geocomplete().data(attribute),
				prop = instance[options];
			if (typeof prop == "function") {
				prop.apply(instance, Array.prototype.slice.call(arguments, 1));
				return $(this);
			} else {
				if (arguments.length == 2) {
					prop = arguments[1];
				}
				return prop;
			}
		} else {
			return this.each(function() {
				var instance = $.data(this, attribute);
				if (!instance) {
					instance = new GeoComplete(this, options);
					$.data(this, attribute, instance);
				}
			});
		}
	};
})(jQuery, window, document);